import { Api } from 'common/utils/api';
import { config } from 'mobile/hooks/config';
import { useMutation } from 'react-query';

interface Props {
    doctorId: number;
}

interface ReturnType {
    uploadUrl: string;
    photoUrl: string;
}

export const useDoctorPhotoUploadStart = () => {
    const { path } = config.doctors.uploadStart();

    const mutation = useMutation((body: Props) => Api.post<ReturnType>({ path, body }));

    return {
        useDoctorPhotoUploadStart: mutation.mutateAsync,
    };
};
